import { render, staticRenderFns } from "./inventory-print.vue?vue&type=template&id=52cdf55e&"
import script from "./inventory-print.vue?vue&type=script&lang=js&"
export * from "./inventory-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports